import { action } from 'satcheljs';

export const startDomainEnroll = action('startDomainEnroll');
